import { Component, OnDestroy, ChangeDetectorRef, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.css']
})
export class ChatComponent implements OnDestroy {
    window:any = <any>window;
    moment:any = <any>this.window.moment;
    disable_send_button:any = false;
    inbox_people_active:any = false;

    update_timeout:any = null;

    get:any = (filter:any = "") => Object.entries(this.window.coffe?.getRecipients() || {})?.reduce((a:any, b:any) => {
        a = a || {};
        const [key, value] = b;
        if(!filter || !!this.getChatName(value)?.toLowerCase()?.includes(filter.toLowerCase())) a[key] = value;
        return a;
    }, {}) || {};

    getMessages:any = () => this.selected?
            this.window.coffe?.getRecipients(this.selected)?.messages || []
         :  [];

    getChatName:any = (recipient:any = {}) => recipient.name || recipient?.usherGroup?.reduce((a, b) => {
      a = a || "";

      if(a.split(", ").includes(b) || b?.username == this.window.usher?.getUsername()) return a;
      if(!!a.length) a += ", ";

      a += b

      return a;
    }, "") || "chat";

    getChatImage:any = (recipient: any = {}) => this.getMedia(
          recipient?.usherGroup?.find(user => user.public_token !== this.window.usher.getPublicToken())?.picture || 'assets/img/user-profile.svg'
    );

    getLastDate:any = (recipient:any) => recipient && this.moment(recipient?.messages[0]?.creation_timestamp || new Date()).fromNow() || "";
    getLastText:any = (recipient:any) => recipient && recipient?.messages[0]?.body || "";

    getUnreadMessages:any = (pt_recipient = false) => pt_recipient?
                  this.window.coffe?.getRecipients(pt_recipient)?.messages?.filter(m =>!m.seen && !m.isOwner) || []
                : Object.values(this.window.coffe?.getRecipients() || []).reduce((a:any, b:any) => {
                      a = a || [];

                      a.push(...(b?.messages?.filter(m => !m.seen && !m.isOwner) || []));

                      return a;
                  }, []);

    updateView:any = (e) => {
      setTimeout(() => this.ngZone.run(async () => {

          this.selected = this.queryparams().selected;
          this.scrollChat(e);
      }), 50);
    };

    scrollToBottom:any = (params:any = {}, steps) => {
        let el = document?.querySelector(params.el || "body") || {};
        return el.scrollTop = el?.scrollHeight;
    };

    scrollChat:any = (params:any = {}) => setTimeout(() => this.scrollToBottom({
        el : params.el || "#msg_history"
    }), params?.delay || 10);

    selected:any;
    body:any = "";
	bodyFirstMessage:any = "";
	titleFirstMessage:any = "";
    filter:any = {
        text: "",
        chat: ""
    };

    send:any = async () => {
        if(!this?.body?.length || !this.selected) return;
        this.disable_send_button = true;
        try {
            await this.window.sf.utils.$http({
                method: "PUT",
                url: `${this.window.appInfo.url_php}/endpoint.php/chat`,
                headers: {
                    "Content-Type": "application/json; charset=utf-8"
                },
                data : {
                    body: this.body,
                    type: "message",
                    private_token: this.window.usher.getPrivateToken(),
                    public_token_recipient: this.selected
                }
            }, true);
            /*
            await this.window?.coffe?.getRecipients(this.selected)?.postMessage({
                body : this.body,
                type : "message"
            });
            */

            this.body = "";
        }
        catch(e) {
            //Notification.error("Errore, riprova più tardi");
            console.log(e);
        }
        this.disable_send_button = false;
    };

    queryparams:any = () => this.route.snapshot.queryParams;
    changeQueryParam:any = (values:any = {}) => new Object({ ...this.route.snapshot.queryParams, ...values });

    getMedia = (media:any = {}) => (media?.includes('www.') || media?.includes('assets/'))? `${media}` : `${this.window.appInfo.url_media}/${media}`;

    getUsersType:any = () => this.window.usher?.getChildren()?.reduce((a:any, b:any) => {
        a = a || [];
        if(!a.includes(b.public_configuration.type)) a.push(b.public_configuration.type);
        return a;
    }, []);

    constructor(
			private cd: ChangeDetectorRef,
	        private route:ActivatedRoute,
	        private router:Router,
			private ngZone: NgZone
	) {
        route.queryParams.subscribe(p => {
            this.initialize();
            this.updateView();

            if(p.selected) this.window.coffe?.getRecipients(p.selected)?.seen(true);
        });
	};

	seeRecipient() {
	      if(this.queryparams().selected && this.getUnreadMessages(this.queryparams().selected).length) {
	          this.window.coffe?.getRecipients(this.queryparams().selected)?.seen(true);
	      }
	};

    initialize = () => {
        if(!this.queryparams()['user-type']) this.router.navigate(['/chat'], { queryParams: this.changeQueryParam({'user-type': this.getUsersType()[0]}) });
    };

    ngAfterContentInit() {
        this.window.scrollTo(0,0);
        this.window.usher.element.addEventListener("change", this.updateView.bind(this));
        this.window.usher.element.addEventListener("change", this.initialize.bind(this));
        this.window.coffe.element.addEventListener("change", this.updateView.bind(this));
        if(this.queryparams().selected) this.window.coffe?.getRecipients(this.queryparams().selected)?.seen(true);

        this.update_timeout = setInterval(() => this.seeRecipient(), 1000);
    };

    ngOnDestroy(){
        clearInterval(this.update_timeout);
        this.window.usher.element.removeEventListener("change", this.updateView.bind(this));
        this.window.usher.element.removeEventListener("change", this.initialize.bind(this));
        this.window.coffe.element.removeEventListener("change", this.updateView.bind(this));
    };

    openModal = (selector:any) => {
        let modal_wrapper = Array.from(this.window.document.querySelector(selector).children || []);
        modal_wrapper.forEach((el:any) => el.style.display = 'block');
    };

    closeModal = (selector:any) => {
        let modal_wrapper = Array.from(this.window.document.querySelector(selector).children || []);
        modal_wrapper.forEach((el:any) => el.style.display = 'none');
    };

	getUsers = () => this.window.usher.getChildren()?.filter(e => !this.queryparams()['user-type'] || e.public_configuration.type == this.queryparams()['user-type'])?.filter(e => !this.filter.text || e.public_configuration.nome?.toLowerCase()?.includes(this.filter.text?.toLowerCase())) || [];

    openChat = async () => {
		let targets:any = this.queryparams()["chat-target"] || "[]",
			recipients:any = [];

		if(!this.window.sf.utils.isJSONString(targets)) targets = "[]";

		targets = JSON.parse(targets) || [];

		if(!targets.length) return;

		if(targets.length == 1) {
	        try {
	            recipients = await this.window.coffe.getRecipientsUsher(targets[0]);
	        }
	        catch(e) {
	          console.log(e);
	          recipients.length = 0;
	        }
		};

		let recipient = recipients.find(rec => rec?.usherGroup?.length == (targets.length + 1) && rec?.usherGroup.find(u => u.public_token == this.window.usher.getPublicToken()));

		this.closeModal('#newChatModal');

		if(!!recipient) {
			this.router.navigate(['/chat'], { queryParams: this.changeQueryParam({ "chat-target" : undefined, "selected" : recipient?.public_token }) });
			Array.from(this.window.document.querySelectorAll("#chat-target input")).forEach((el:any) => el.checked = false);
			this.updateView();
			return;
		};

		this.openModal('#firstChatModal');

    };

	sendFirstMessage = async () => {
        if(!this.bodyFirstMessage.length) return

        if(!this.queryparams()["chat-target"]) return this.closeModal('#firstChatModal');

		let targets:any = this.queryparams()["chat-target"] || "[]",
			recipients:any = [];

		if(!this.window.sf.utils.isJSONString(targets)) targets = "[]";

		targets = JSON.parse(targets) || [];

		if(!targets.length) return;
		if(!this.titleFirstMessage.length && targets.length >= 2) return;

      	try {
            let response = await this.window.sf.utils.$http({
                method: "POST",
                url: `${this.window.appInfo.url_php}/endpoint.php/chat`,
                headers: {
                    "Content-Type": "application/json; charset=utf-8"
                },
                data : {
                    subject: "",
                    body: this.bodyFirstMessage,
                    type: "message",
                    name: this.titleFirstMessage,
                    private_token: this.window.usher.getPrivateToken(),
                    targets: targets
                }
            })
            this.closeModal('#firstChatModal');

            this.router.navigate(['/chat'], { queryParams: this.changeQueryParam({ "chat-target" : undefined, "selected" : `${response?.recipient}` }) });
            Array.from(this.window.document.querySelectorAll("#chat-target input")).forEach((el:any) => el.checked = false);
            this.bodyFirstMessage = "";
            this.titleFirstMessage = "";
         return;
      }
      catch(e) {
          //Notification.error("Errore, riprova più tardi");
          console.log(e);
      }
    };

	deleteChat = async () => {
        if(!this.selected) return;
        try {
            await this.window.sf.utils.$http({
                method: "DELETE",
                url: `${this.window.appInfo.url_php}/endpoint.php/chat`,
                headers: {
                    "Content-Type": "application/json; charset=utf-8"
                },
                data : {
                    private_token: this.window.usher.getPrivateToken(),
                    public_token_recipient: this.selected
                }
            }, true)
            this.closeModal('#deleteChatModal');
            return;
        } catch(e) {
            //Notification.error("Errore, riprova più tardi");
            console.log(e);
        }
	};

  showImage = (url:any) => this.window.flowup.signal.emit({name: 'show-image', detail: { images: [url] }});

	onChangeUserSelector(event:any, i:any) {

		let value = !!event?.target?.checked,
			target = this.getUsers()[i],
			params = this.queryparams()["chat-target"] || "[]";

		if(!this.window.sf.utils.isJSONString(params)) params = "[]";

		params = JSON.parse(params) || [];
		let index = params.findIndex((el:any) => el == target?.public_token);

		if((index>=0 && value) || (index<0 && !value)) return;
		if(index>=0) {
			params.splice(index, 1);
		};

		if(index<0) {
			params.push(target.public_token);
		};

		this.router.navigate(['/chat'], { queryParams: this.changeQueryParam({ "chat-target" : JSON.stringify(params) }) });
    };

    getLinkChat = (pt_recipient:any) => `${this.window.appInfo.url_php}/generatepdf.php?private_token=${this.window.usher.getPrivateToken()}&public_token_recipient=${pt_recipient}`;
}
